import { cn } from '@/lib/core/utils/cn';
import type { LocationDto } from '@/services/platform/api/model';

export const LOCATION_DROPDOWN_PANEL_ID = 'location-dropdown-panel';

interface LocationDropdownProps {
  locations: LocationDto[];
  /** The location already showing on the map — filtered out of the list. */
  activeNodeKey?: string;
  onSelect: (location: LocationDto) => void;
  className?: string;
}

/**
 * Location picker for the Explore map header. Floats over the map as an overlay panel rather
 * than pushing it down, and rather than the old bottom-sheet drawer.
 */
export function LocationDropdown({ locations, activeNodeKey, onSelect, className }: LocationDropdownProps) {
  const options = locations.filter(loc => loc.nodeKey !== activeNodeKey);

  return (
    <div
      id={LOCATION_DROPDOWN_PANEL_ID}
      className={cn('bg-jncquoi-neutral-00 flex max-h-[60dvh] flex-col overflow-y-auto pb-4', className)}
    >
      {options.map(loc => (
        <button
          key={loc.nodeKey}
          type="button"
          className="flex w-full items-center px-4 py-3"
          onClick={() => onSelect(loc)}
        >
          <span className="font-didot text-jncquoi-neutral-1000 pl-2 text-[36px] leading-[34px] tracking-[-1.8px] uppercase italic">
            {loc.name}
          </span>
        </button>
      ))}
    </div>
  );
}
